<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("summary") }} v2</div>
      <div class="mb-4">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="getSummaryReportSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getSummaryReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="
                    onSummaryReportDropdownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <!-- <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate">✖</button>
                <Datepicker :monday-first="true" ></Datepicker>
                <label>{{ $t("fromdate") }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate">✖</button>
                <Datepicker :monday-first="true" ></Datepicker>
                <label>{{ $t("todate") }}</label>
              </div>
            </div>
          </div> -->
          <!-- FROM DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getSummaryReportFromDate"
                  v-on:click="
                    onSummaryReportDateHandler({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onSummaryReportDateHandler({
                      event: $event,
                      name: 'fromDate'
                    })
                  "
                  ref="programaticOpen"
                  :value="getSummaryReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getSummaryReportFromDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>
          <!-- TO DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getSummaryReportToDate"
                  v-on:click="
                    onSummaryReportDateHandler({ event: null, name: 'toDate' })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onSummaryReportDateHandler({
                      event: $event,
                      name: 'toDate'
                    })
                  "
                  ref="programaticOpen"
                  :value="getSummaryReportToDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getSummaryReportToDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-3">
            <button
              @click.prevent.stop="fetchSummaryReportList"
              class="btn-blue"
            >
              {{ $tc("fetch") }}
            </button>
          </div>

          <!-- <div class="col-lg-4 col-xl-3 align-self-center">
                <a style="color: #3876d2;" href=""><img src="@/assets/img/icons/download.svg" height="20" width="20"/> Download</a>
            </div> -->
          <div
            class="col-lg-4 col-xl-3 align-self-center"
            v-if="getSummariesPDFFileName"
          >
            <a
              v-if="getSummariesPDFFileName"
              :href="BASE_URL + getSummariesPDFFileName"
              target="_blank"
              download
              class="btn-transparent ml-3"
              title="Download as PDF"
              style="color: #3876d2"
              ><img
                src="@/assets/img/icons/download.svg"
                height="20"
                width="20"
              />
              Download
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-lg-6 col-xl-6 mb-4">
        <div class="reports-box">
          <div class="d-flex align-items-center justify-content-between pb-2">
            <div class="title">SUMMARY</div>
            <div class="text-dark">
              <a href="">
                <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="light-title">Total Admits</div>
            </div>
            <div class="col-4">
              <div class="light-title">Total Transactions</div>
            </div>
            <div class="col-4">
              <div class="light-title">Total Screens</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummaries.TotalAdmits || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummaries.TotalTransactions || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummaries.TotalScreens || "0" }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">Total Seat In Cinema</div>
            </div>
            <div class="col-4">
              <div class="light-title">Total No Of Show</div>
            </div>
            <div class="col-4">
              <div class="light-title">Total Revenue</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummaries.TotalSeatsInCinema || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummaries.TotalNoofShows || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummaries.TotalRevenue) || "0" }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">Average Shows</div>
            </div>
            <div class="col-4">
              <div class="light-title">Average Seats Per Screen</div>
            </div>
            <div class="col-4">
              <div class="light-title">Average Shows Per Day</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummaries.AvgShows) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummaries.AverageShowsPerScreen) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummaries.AverageShowsPerDayPerScreen) || "0"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-6">
        <div class="reports-box">
          <div class="d-flex align-items-center justify-content-between pb-2">
            <div class="title">BOX OFFICE</div>
            <div class="text-dark">
              <a href="">
                <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="light-title">Box Office Revenue(BOR)</div>
            </div>
            <div class="col-4">
              <div class="light-title">Tax</div>
            </div>
            <div class="col-4">
              <div class="light-title">Additional Charges</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesBoxOffice.TotalBoxOfficeRevenue) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.TotalTax) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.AdditionalCharges) || "0" }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">Net BOR</div>
            </div>
            <div class="col-4">
              <div class="light-title">Total Transactions</div>
            </div>
            <div class="col-4">
              <div class="light-title">ATP</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.NetRevenue) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummariesBoxOffice.TotalTransaction || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.ATP) || "0" }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">Net ATP</div>
            </div>
            <div class="col-4">
              <div class="light-title">Occupancy %</div>
            </div>
            <div class="col-4">
              <div class="light-title"></div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.NetATP) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesBoxOffice.OccupancyRate) || "0" }}
              </div>
            </div>
            <!-- <div class="col-4">
                                    <div class="total-dark">4</div>
                                </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-6">
        <div class="reports-box">
          <div class="d-flex align-items-center justify-content-between pb-2">
            <div class="title">{{ $t("concession") }}</div>
            <div class="text-dark">
              <!-- <a href="">
                                        <img src="@/assets/img/icons/download.svg" height="20" width="20"/>
                                    </a> -->
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="light-title">
                {{ $t("gross") }} {{ $t("revenue") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">{{ $t("tax") }}</div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("concession") }} {{ $t("net") }} {{ $t("revenue") }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcession.GrossConcessionRevenue) ||
                    "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcession.TaxConcessionRevenue) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcession.NetConcessionRevenue) || "0"
                }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("cost") }} Of {{ $t("goods") }} {{ $t("sold") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("gross") }} {{ $t("spend") }} {{ $t("per") }}
                {{ $t("head") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">{{ $t("transactions") }}</div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ currFormat(getSummariesConcession.CostOfGoods) || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcession.GrossSpendPerHead) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  getSummariesConcession.NumberOfConcessionsTransactions || "0"
                }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("admission") }} {{ $t("strike") }} {{ $t("rate") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("average") }} {{ $t("value") }} {{ $t("per") }}
                {{ $t("transactions") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("no") }} of {{ $t("items") }} {{ $t("sold") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("quantity") }} of {{ $t("items") }} {{ $t("sold") }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcession.AdmissionStrikeRate) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(
                    getSummariesConcession.AverageValuePerTransaction
                  ) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummariesConcession.NoOfItemsSold || "0" }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{ getSummariesConcession.QuantityOfItemsSold || "0" }}
              </div>
            </div>
            <table
              style="width: calc(100% - 30px)"
              border="1"
              class="mx-auto mb-3"
            >
              <tr>
                <td class="p-1">{{ $t("items") }} {{ $t("name") }}</td>
                <td class="p-1">Qty {{ $t("sold") }}</td>
                <td class="p-1">{{ $t("gross") }} {{ $t("revenue") }}</td>
                <td class="p-1">{{ $t("profit") }} {{ $t("margin") }}</td>
              </tr>
              <tr
                v-for="(items,
                itemIndex) in getSummariesConcession.TopFiveItemsSold"
                :key="itemIndex"
              >
                <td class="p-1">{{ items.recipe_name }}</td>
                <td class="p-1">{{ items.count }}</td>
                <td class="p-1">
                  {{ currFormat(items.fp_total_amount * items.count) }}
                </td>
                <td class="p-1">
                  {{
                    currFormat(
                      items.fp_total_amount * items.count -
                        items.fp_cost_of_item * items.count
                    )
                  }}
                </td>
              </tr>
            </table>

            <!-- <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('items') }} {{ $t('name') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Qty {{ $t('sold') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('gross') }} {{ $t('revenue') }}</div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.NetATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.OccupancyRate.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">4</div>
                                </div>
                                <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">{{ $t('profit') }} {{ $t('margin') }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title"></div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title"></div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">{{ getSummariesBoxOffice.NetATP.toFixed(this.MIN_FRACTION_DIGITS) || '0' }}</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark"></div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark"></div>
                                </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-6">
        <div class="reports-box">
          <div class="d-flex align-items-center justify-content-between pb-2">
            <div class="title">{{ $t("concession") }} {{ $t("profit") }}</div>
            <div class="text-dark">
              <a href="">
                <!-- <img src="@/assets/img/icons/download.svg" height="20" width="20"/> -->
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="light-title">
                {{ $t("profit") }} At {{ $t("standard") }} {{ $t("cost") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("average") }} {{ $t("profit") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("average") }} {{ $t("profit") }} {{ $t("per") }}
                {{ $t("items") }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(
                    getSummariesConcessionProfit.ProfitAtStandardCost
                  ) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(getSummariesConcessionProfit.AverageProfit) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(
                    getSummariesConcessionProfit.AverageProfitPerItem
                  ) || "0"
                }}
              </div>
            </div>
            <div class="col-12">
              <hr class="my-2" />
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $t("profit") }} {{ $t("per") }} {{ $t("head") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title">
                {{ $tc("price", 1) }} {{ $t("per") }} {{ $t("transactions") }}
              </div>
            </div>
            <div class="col-4">
              <div class="light-title"></div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  getSummariesConcessionProfit.ProfitPerHead.toFixed(this.MIN_FRACTION_DIGITS) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark">
                {{
                  currFormat(
                    getSummariesConcessionProfit.PricePerTransaction
                  ) || "0"
                }}
              </div>
            </div>
            <div class="col-4">
              <div class="total-dark"></div>
            </div>
            <!-- <div class="col-12">
                                    <hr class="my-2">
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Screen</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Screen Per Show</div>
                                </div>
                                <div class="col-4">
                                    <div class="light-title">Average Show Per Day</div>
                                </div>
                                 <div class="col-4">
                                    <div class="total-dark">140</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">3</div>
                                </div>
                                <div class="col-4">
                                    <div class="total-dark">4</div>
                                </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
export default {
  data() {
    return {
      summaryFromDate: "",
      summaryToDate: ""
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getCinemasList",
      "getSummaryReportsIsCinema",
      // End
      // DropDownList
      // DropDown
      // Get DropDown Selected Values
      "getSummaryReportFromDate",
      "getSummaryReportSelectedCinema",
      "getSummaryReportToDate",
      // List
      "getSummaries",
      "getSummariesBoxOffice",
      "getSummariesConcession",
      "getSummariesConcessionProfit",
      // PDF
      "getSummariesPDFFileName"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onSummaryReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    this.onSummaryReportFlagHandler({
      event: null,
      name: "isCountry",
      value: this.secureStore.get("BRGLOPCO") || null
    });
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSummaryReportDropdownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onSummaryReportDropdownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  mounted() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.fetchCinemasList({ cinemaId });
  },
  methods: {
    ...mapActions([
      //
      "fetchSummaryReportList",
      "fetchCinemasList",
      //
      "onSummaryReportDateHandler",
      "onSummaryReportDropdownHandler",
      "onSummaryReportFlagHandler",
      "onResetSummaryStoreState"
    ]),
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    }
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getSummariesPDFFileName
    });
    await this.onResetSummaryStoreState();
  }
};
</script>
<style>
.reports-box {
  height: auto;
  padding: 10px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.reports-box .title {
  color: #3876d2;
  font-weight: bold;
  font-size: 20px;
}

.reports-box .light-title {
  font-size: 12px;
  color: #a7a7a7;
}

.reports-box .total-dark {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/summaryv2.vue